var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowFatUp = function SvgIconArrowFatUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.293 1.543a1 1 0 0 1 1.414 0l9 9A1 1 0 0 1 21 12.25h-3.5v7.25a1.75 1.75 0 0 1-1.75 1.75h-7.5A1.75 1.75 0 0 1 6.5 19.5v-7.25H3a1 1 0 0 1-.707-1.707zM5.414 10.25H7.5a1 1 0 0 1 1 1v8h7v-8a1 1 0 0 1 1-1h2.086L12 3.664z",
    clipRule: "evenodd"
  })));
};
export default SvgIconArrowFatUp;